import { ChangeDetectionStrategy, Component, Inject, OnInit } from "@angular/core";
import { NewUiButton, NewUiProgressBarComponent } from "@ankaadia/ankaadia-shared-frontend";
import type { ProgressMode } from "@ankaadia/ankaadia-shared-frontend";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { TranslateDirective } from "../../transloco/translate.directive";

@Component({
  selector: "new-ui-progress-dialog",
  templateUrl: "./new-ui-progress-dialog.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateDirective, NewUiButton, NewUiProgressBarComponent],
})
export class NewUiProgressDialogComponent implements OnInit {
  progressId: string;
  cancelable: boolean;
  initialMessage: string;
  mode: ProgressMode;

  constructor(
    @Inject(DynamicDialogRef)
    protected readonly dialogRef: DynamicDialogRef,
    @Inject(DynamicDialogConfig)
    protected readonly config: DynamicDialogConfig
  ) {}

  ngOnInit(): void {
    this.progressId = this.config.data.progressId ?? "1";
    this.cancelable = this.config.data.cancelable ?? true;
    this.initialMessage = this.config.header ?? "...";
    this.mode = this.config.data.mode ?? "activity-indicator";
  }

  cancel(): void {
    this.dialogRef.close("cancelled");
  }
}
